import React from 'react';
import { motion } from 'framer-motion';
import * as BsIcons from 'react-icons/bs';
import SafeIcon from '../common/SafeIcon';

const { BsJournalMedical, BsActivity, BsLightbulb } = BsIcons;

const Resources = () => {
  const articles = [
    {
      title: "The BDNF Breakthrough",
      tag: "Neuroscience",
      img: "https://cdn1.sharemyimage.com/smi/2026/01/01/3d-medical-background-with-male-head-brain-dna-strands.jpg",
      desc: "How Brain-Derived Neurotrophic Factor acts as a 'fertilizer' for your neural networks."
    },
    {
      title: "Audio Entrainment Explained",
      tag: "Sound Therapy",
      img: "https://cdn1.sharemyimage.com/smi/2026/01/01/scientist-interacts-with-digital-brain-model-hightech-research-lab-setting.jpg",
      desc: "The science of using sound frequencies to guide brainwave activity into Gamma states."
    },
    {
      title: "Cognitive Longevity in 2025",
      tag: "Longevity",
      img: "https://cdn1.sharemyimage.com/smi/2026/01/01/doctor-from-future-concept.jpg",
      desc: "New protocols for maintaining mental sharpness as you age."
    }
  ];

  return (
    <div className="pt-32 pb-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="max-w-3xl mb-16">
          <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6">Brain Health Library</h1>
          <p className="text-xl text-slate-600">Expert-vetted resources on neuro-optimization, cognitive health, and mental wellness.</p>
        </header>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article, idx) => (
            <motion.div 
              key={idx}
              className="group cursor-pointer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
            >
              <div className="relative aspect-[16/10] rounded-2xl overflow-hidden mb-6">
                <img src={article.img} alt={article.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest text-indigo-600">
                  {article.tag}
                </div>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-indigo-600 transition-colors">{article.title}</h3>
              <p className="text-slate-600 leading-relaxed text-sm">{article.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Resources;